export default "__VITE_ASSET__6ZPttoEc__"